<template>
  <div class="jijiagongApp-page">
    <!-- 能效管理 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="caseDetails-banner-container">
      <div class="case-info-container">
        <p class="case-title">机加工互联</p>
        <p class="case-describe">说明文案说明文案说明文案说明文案说明文案说</p>
        <!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
      </div>
    </div>
    <div class="caseDetails-all-content-container">
      <div class="case-introduce-item-container Fun1">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-img-item-container">
              <div class="text-container">
                <p class="interface-title">机加工</p>
                <p class="interface-describe">说明文案说明文案说明文案说明文案</p>
              </div>
              <div class="img-container">
                <img src="../../assets/img/caseDetails/jijiagongApp/default_img1.png" alt="" class="interface-img">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container Fun2">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-img-item-container">
              <div class="text-container">
                <p class="interface-describe">说明文案说明文案</p>
              </div>
              <img src="../../assets/img/caseDetails/jijiagongApp/default_img2.png" alt="" class="interface-img default_img2">
              <img src="../../assets/img/caseDetails/jijiagongApp/default_img4.png" alt="" class="interface-img default_img4">
            </div>
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container Fun3">
        <div class="caseDetails-center-content-container">
          <div class="introduce-content-container">
            <div class="text-img-item-container">
              <div class="text-container">
                <p class="interface-describe">说明文案说明文案</p>
              </div>
              <div class="img-container">
                <img src="../../assets/img/caseDetails/jijiagongApp/default_img5.png" alt="" class="interface-img">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'jijiagongApp',
  components:{
    Header,
    Nav,
    Foot
  },
}
</script>
<style lang="scss">
  
</style>